import React from 'react';
import './MapAddress.css'


const MapAddress = () => {
  return (
    <div className="iq-map">
      <iframe title="navigation" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3534.1202845482476!2d153.1654480150609!3d-27.65174998281494!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b914230a0da8d95%3A0x66b04b245cc6d586!2sSoftlink%20House%2C%2068%20Commercial%20Dr%2C%20Shailer%20Park%20QLD%204128%2C%20Australia!5e0!3m2!1sen!2s!4v1587430720999!5m2!1sen!2s" ></iframe>
    </div>
  )
}

export default MapAddress;